import { Grid2, Paper } from '@mui/material';
import { SectionTitle } from './SectionTitle';
import { ReactNode } from 'react';

export interface TitledSectionProps {
  icon?: string;
  title: string;
  tags?: string[];
  children: ReactNode;
}

export const TitledSection = ({ title, icon, tags, children }: TitledSectionProps) => {
  return (
    <Paper sx={{ p: 2 }}>
      <Grid2 container columnSpacing={3} rowSpacing={{ xs: 2, md: 2 }}>
        <Grid2 container spacing={1} size={12} alignItems="center">
          <SectionTitle tags={tags} title={title} icon={icon} />
        </Grid2>
        {children}
      </Grid2>
    </Paper>
  );
};
